import React, { Component } from 'react';
import { connect } from "react-redux";
import PulseLoader from 'react-spinners/PulseLoader'
import LoginModal from 'components/modals/LoginModal.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import GuildDetailView from './GuildDetailView.js';
import GuildsListView from './GuildsListView.js';
import NewMemberRequests from './NewMemberRequests.js';
import CreateNewGuild from './CreateNewGuild.js';
import ethereum from 'decentralized/ethereum.js';

class GuildsContentView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editingGuild: undefined,
            editingName: false,
            guilds: [],
            waitingForNewGuild: false,
            creatingNewGuild: false,
            name: '',
            passphrase: '',
            usersSelected: new Set()
        }

        this.onNameChange = this.onNameChange.bind(this);
        this.onPassphraseChange = this.onPassphraseChange.bind(this);
        this.onClickGuild = this.onClickGuild.bind(this);
        this.getGuilds();

        ethereum.guilds.newGuildCallback = () => this.getGuilds();
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.userToken !== this.props.userToken) {
            this.getGuilds();
        }
        return true;
    }

    selectUser(userId) {
        if (this.state.usersSelected.has(userId)) {
            this.state.usersSelected.delete(userId);
        } else {
            this.state.usersSelected.add(userId);
        }

        this.setState(this.state);
    }

    onNameChange(val) {
        this.setState({
            name: val,
            editingName: true,
        });
    }

    async doneEditing() {
        if (this.state.editingName && this.state.editingGuild) {
            if (this.state.editingGuild.name !== this.state.name) {
                // then we need to rename the guild
                this.state.editingGuild.name = this.state.name
                ethereum.guilds.setGuildName(
                    this.state.editingGuild.guildId,
                    this.state.name);
            }
        }
        if (this.state.usersSelected.size > 0) {
            // add to guild
            let guildId = this.state.editingGuild.guildId;
            this.state.usersSelected.forEach(
                async userId => await ethereum.guilds.requestToAddMember(guildId, userId));
        }
        this.setState({editingGuild: undefined, editingName: false});
    }

    onClickGuild(guild) {
        this.setState({
            name: '',
            editingGuild: guild
        });
    }

    onPassphraseChange(val) {
        this.setState({passphrase: val});
    }

    createNewGuild(name, passphrase) {
        ethereum.guilds.newGuild(name, passphrase);

        this.setState({
            waitingForNewGuild: true
        })
    }

    onClickNewGuild(creatingNewGuild) {
        if (!creatingNewGuild) {
            this.createNewGuild(this.state.name, this.state.passphrase);
        }

        this.setState({
            creatingNewGuild: creatingNewGuild
        });
    }

    async getGuilds() {
        let guilds = await ethereum.guilds.getGuildsForUser();
        for (let i in guilds) {
            let guild = guilds[i];
            let members = await ethereum.guilds.getUsersInGuild(guild.guildId);
            guild.members = members;
        }
        this.setState({
            waitingForNewGuild: false,
            guilds: guilds
        });
    }

    render() {
        if (this.state.editingGuild) {
            return (
                <div className="content-view">
                  <div className="inner-content-view">
                    <GuildDetailView
                      selectUser={(user) => this.selectUser(user)}
                      usersSelected={this.state.usersSelected}
                      name={this.state.name}
                      isEditingName={this.state.editingName}
                      onNameChange={(name) => this.onNameChange(name)}
                      guild={this.state.editingGuild}
                      onFinishEditing={() => this.onClickGuild(undefined)}/>
                  </div>
                  <div
                    onClick={() => this.doneEditing()}
                    className="add-guilds-button">
                    <div
                      className="button-text">
                      {this.state.usersSelected.size > 0 ? 'Add Members to Guild' : 'Done'}
                  </div>
                  </div>
                </div>
            );
 
        }

        return (
            <div className="content-view">
              <LoginModal show={this.props.showLogin}/>
              <div className="inner-content-view">
                <div className="sub-header">
                  <div>{this.state.creatingNewGuild ? 'Create New Guild' : 'Guilds'}</div>
                </div>
                <div className="clear-fix"/>
                <ConditionedComponent condition={this.state.waitingForNewGuild}>
                  <div className="creating-new-guild">
                    Creating new guild
                  </div>
                  <PulseLoader
                    sizeUnit={"px"}
                    size={10}
                    color={'#123abc'}
                    loading={this.state.waitingForNewGuild}/>
                </ConditionedComponent>
                <ConditionedComponent condition={this.state.creatingNewGuild}>
                  <CreateNewGuild
                    onPassphraseChange={this.onPassphraseChange}
                    onNameChange={this.onNameChange}
                    passphrase={this.state.passphrase}
                    name={this.state.name}/>
                </ConditionedComponent>
                <ConditionedComponent condition={!this.state.creatingNewGuild}>
                  <GuildsListView
                    onClickGuild={(guild) => this.onClickGuild(guild)}
                    guilds={this.state.guilds}/>

                    <NewMemberRequests ethereum={ethereum}/>
                </ConditionedComponent>
              </div>
              <div
                onClick={() => this.onClickNewGuild(!this.state.creatingNewGuild)}
                className="add-guilds-button">
                <ConditionedComponent condition={this.state.creatingNewGuild}>
                  <div
                    className="button-text">
                  Done
                  </div>
                </ConditionedComponent>
                <ConditionedComponent condition={!this.state.creatingNewGuild}>
                  <div className="big-plus">+</div>
                  <div
                    className="button-text">
                    New Guild
                  </div>
                </ConditionedComponent>
              </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        showLogin: state.sequencer.showLogin,
        userToken: state.sequencer.userToken,
    }
};


export default connect(mapStateToProps, null)(GuildsContentView);

